var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46934 0.970154C0.609965 0.829704 0.800589 0.750814 0.99934 0.750814C1.19809 0.750814 1.38871 0.829704 1.52934 0.970154L5.99934 5.44015L10.4693 0.970154C10.538 0.896467 10.6208 0.837365 10.7128 0.796373C10.8048 0.755381 10.9041 0.733339 11.0048 0.731562C11.1055 0.729785 11.2055 0.74831 11.2989 0.786031C11.3923 0.823752 11.4772 0.879897 11.5484 0.951116C11.6196 1.02233 11.6757 1.10717 11.7135 1.20056C11.7512 1.29394 11.7697 1.39397 11.7679 1.49468C11.7662 1.59538 11.7441 1.69469 11.7031 1.78669C11.6621 1.87869 11.603 1.96149 11.5293 2.03015L6.52934 7.03015C6.38871 7.1706 6.19809 7.24949 5.99934 7.24949C5.80059 7.24949 5.60997 7.1706 5.46934 7.03015L0.46934 2.03015C0.328889 1.88953 0.25 1.6989 0.25 1.50015C0.25 1.3014 0.328889 1.11078 0.46934 0.970154Z",
    fill: "#47525C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.4c69d19d64805d1445fd1c06b1b9d0ab.svg";
export { ForwardRef as ReactComponent };